import { NATURAL_PALETTE, naturalColor } from '@/components/ui/chartFormat';

/*
 * Stable colours per game funding source, so the donut and the stacked daily
 * bars agree at a glance. Sources the backend hasn't classified yet take the
 * shared palette (offset past the fixed hues so they stay distinguishable).
 * Kept out of index.tsx so that file only exports components (react-refresh).
 */
const SOURCE_COLORS: Record<string, string> = {
  free: NATURAL_PALETTE[0], // moss
  purchased: NATURAL_PALETTE[2], // ochre
  unknown: NATURAL_PALETTE[15], // taupe
};

export function sourceColor(key: string, index = 0): string {
  return SOURCE_COLORS[key] ?? naturalColor(index + 3);
}
